export const MAX_JIGSAW_NUM = 16;

export const minNumberByType = (type: string) => {
  if (type === 'long') {
    return 2;
  }
  if (type === 'poster') {
    return 1;
  }

  return 1;
};

export const maxNumberByType = (type: string): number => {
  if (type === 'long') {
    return 12;
  }
  if (type === 'poster') {
    return 1;
  }
  if (type === 'download' || type === 'share') {
    return 50;
  }

  return 9;
};